export const ADS_GET_CONTACTS = "ADS_GET_CONTACTS";
export const ADS_CHANGE_CONTACT_STATUS = "ADS_CHANGE_CONTACT_STATUS";
export const ADS_DELETE_CONTACT = "ADS_DELETE_CONTACT";